// Chat notification sound service
// Uses Web Audio API to generate a simple notification sound

class NotificationSound {
  constructor() {
    this.audioContext = null
    this.enabled = true
  }

  init() {
    if (!this.audioContext) {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
    }
  }

  // Play a pleasant notification "ding" sound
  play() {
    if (!this.enabled) return
    
    try {
      this.init()
      
      const ctx = this.audioContext
      const now = ctx.currentTime
      
      // Create oscillator for the tone
      const oscillator = ctx.createOscillator()
      const gainNode = ctx.createGain()
      
      oscillator.connect(gainNode)
      gainNode.connect(ctx.destination)
      
      // Pleasant notification frequency (G5 note)
      oscillator.frequency.setValueAtTime(784, now)
      oscillator.type = 'sine'
      
      // Quick fade in and out for a soft "ding"
      gainNode.gain.setValueAtTime(0, now)
      gainNode.gain.linearRampToValueAtTime(0.3, now + 0.01)
      gainNode.gain.exponentialRampToValueAtTime(0.01, now + 0.3)
      
      oscillator.start(now)
      oscillator.stop(now + 0.3)
      
    } catch (error) {
      console.debug('Could not play notification sound:', error)
    }
  }

  // Play a double-ding for emphasis (optional)
  playDouble() {
    if (!this.enabled) return
    
    this.play()
    setTimeout(() => this.play(), 150)
  }

  enable() {
    this.enabled = true
  }

  disable() {
    this.enabled = false
  }

  toggle() {
    this.enabled = !this.enabled
    return this.enabled
  }
}

export const notificationSound = new NotificationSound()